/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AwsServiceDownloadMoviePresignResponse } from './AwsServiceDownloadMoviePresignResponse';

export type AwsServiceDownloadMoviePresignResponseApiRespoonse = {
    data?: AwsServiceDownloadMoviePresignResponse;
    status?: AwsServiceDownloadMoviePresignResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AwsServiceDownloadMoviePresignResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

